var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('div', {
    attrs: {
      "id": "confirmation"
    }
  }, [_c('h1', {
    staticClass: "mt-4 mb-8 text-center"
  }, [_vm._v("We've updated our agreements")]), _vm._v(" "), _c('img', {
    staticClass: "ml-auto mr-auto card-img",
    attrs: {
      "src": require("assets/images/card-half-transparent.png")
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "space-y-5"
  }, [_c('div', {
    staticClass: "flex flex-row items-center space-x-5 justify-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.agreeToAllTerms,
      expression: "agreeToAllTerms"
    }],
    attrs: {
      "id": "line_of_credit_agreement-input",
      "value": "cardholder_agreement",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeToAllTerms) ? _vm._i(_vm.agreeToAllTerms, "cardholder_agreement") > -1 : _vm.agreeToAllTerms
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.agreeToAllTerms,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "cardholder_agreement",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreeToAllTerms = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.agreeToAllTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.agreeToAllTerms = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "leading-5",
    attrs: {
      "for": "line_of_credit_agreement-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tI agree to Extra's\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank",
      "href": _vm.policy.url
    },
    on: {
      "click": _vm.policyS3Redirect
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.policy.title) + " ")]), _vm._v(".\n\t\t\t\t\t\t\t\t"), _c('br')])])]), _vm._v(" "), _c('button', {
    staticClass: "mt-8 text-lg leading-6 border-none",
    class: !_vm.readyToSubmit ? 'disabled button--gray button--filled' : 'button--mint button--filled',
    attrs: {
      "disabled": !_vm.readyToSubmit,
      "type": "submit",
      "name": "confirm-plan"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.continueButtonAction.apply(null, arguments);
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tI Agree & Acknowledge\n\t\t\t\t\t")])])]), _vm._v(" "), _c('small', {
    staticClass: "my-4 mt-4 text-sm leading-5 opacity-50 text-center"
  }, [_vm._v("\n\t\t\t\tYou can access these documents in the Extra app\n\t\t\t")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };